module.exports = __webpack_public_path__ + "img/Group 946.9a1c6b71.png";